// Redirects legacy new-task routes to the Today view with the add-task flow open.
import { Navigate } from 'react-router-dom';

const NewTaskRedirect = () => <Navigate to="/app/today?new-task" replace />;

export default NewTaskRedirect;
